export default function updateApprovals(approvals) {
    return {
        type: updateApprovals.type,
        payload: approvals,
    };
}

updateApprovals.type = 'UPDATE_APPROVALS';
